/* @flow */
import MessageDelivery from 'entities/MessageDelivery';
import Collection from 'lib/Collection';

class MessageDeliveries extends Collection {
  initialize() {
    this.model = MessageDelivery;
  }

  findWhereMessageId(messageId: string) {
    return this.findWhere({ message_uuid: messageId });
  }
}

export default MessageDeliveries;



// WEBPACK FOOTER //
// ./src/collections/MessageDeliveries.js